import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PepRosterStart.html?raw';
import topic from 'dojo/topic';

import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';

import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';


import FilterPanelOption from '../../moreCore/UI/FilterPanel/FilterPanelOption';

import PepTable from './PepRosterTable';

import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';


import { FilterPanelTypes } from "../../moreCore/UI/FilterPanel/FilterPanelTypes";
import { FeatureHelpers, ToasterHelpers } from "../../more/Helpers";
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import { FilterPanelWidget } from "../../moreCore/_loadingHelpers/Filterpanel";
import { PEP } from "./PepTypes";



class PepRosterStart extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private hiddenSection: HTMLDivElement;
    private filterPanelContainer: HTMLDivElement;
    private filterContainer: HTMLDivElement;
    private filterSection: HTMLDivElement;
    private pepTableContainer: HTMLDivElement;
    private btnSubmit: HTMLButtonElement;
    private btnSubmitLabel: HTMLElement;
    private sectionBtnSubmit: HTMLDivElement;
    private resultMessageErrorContainer: HTMLElement;
    private resultMessageError: HTMLElement;
    private pepTableSection: HTMLDivElement;
    private modeButtonsContainer: HTMLDivElement;
    private btnCloseTable: HTMLButtonElement;
    private closeTableContainer: HTMLDivElement;
    private buttonsRowContainer: HTMLDivElement;
    private topContainerFiller: HTMLDivElement;

    private settingsDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    private displaySettings: HTMLDivElement;
    private displaySettingsContainer: HTMLDivElement;
    private displaySettingsSection: HTMLDivElement;
    private urlForwardingContainer: HTMLDivElement;

    private selectTemplateContainer: HTMLDivElement;

    private templateInfoContainer: HTMLDivElement;
    //txtTemplateInfoStart: HTMLElement;
    //txtTemplateInfoEnd: HTMLElement;
    //txtTemplateInfoBreak: HTMLElement;
    //txtSelectedTemplateHeading: HTMLElement;
    private txtTemplateLabel: HTMLElement;
    private txtTemplateValue1: HTMLElement;
    private txtTemplateValue2: HTMLElement;
    private txtTemplateEmploymentType: HTMLElement;

    private btnModeDefault: HTMLButtonElement;
    private btnModeNotes: HTMLButtonElement;
    private btnModeDelete: HTMLButtonElement;
    private btnModeBrush: HTMLButtonElement;
    private btnModeAdd: HTMLButtonElement;
    private btnModeCostUnit: HTMLButtonElement;
    private btnModeEdit: HTMLButtonElement;
    private topBarContainer: HTMLDivElement;
    private templateInfoFlexRow: HTMLDivElement;
    private cancelCustomTemplateContainer: HTMLDivElement;
    private btnSettings: HTMLButtonElement;
    private btnCancelCustomTemplate: HTMLButtonElement;

    private iconBrushPlus: HTMLElement;

    private mainHeading: HTMLHeadingElement;

    private templateSelect: MdsLax<InstanceType<typeof SelectBox>>;
    private cbDisplayNoteInGrid: MdsLax<InstanceType<typeof CheckBox>>;
    private cbDisplayCompact: MdsLax<InstanceType<typeof CheckBox>>;
    private cbDisplayValuesInSmallInfo: MdsLax<InstanceType<typeof CheckBox>>;
    private cbDisplayDayNotesInHeader: MdsLax<InstanceType<typeof CheckBox>>;
    private cbDisplayDayDescriptionInHeader: MdsLax<InstanceType<typeof CheckBox>>;
    private cbDisplaySpecialNotesInHeader: MdsLax<InstanceType<typeof CheckBox>>;

    private rgDayHeaderEntityviewLabelVariant: MdsLax<InstanceType<typeof RadioGroup>>;
    private dayHeaderEntityviewOptions: HTMLElement;

    private clickmode: PEP.ClickMode = PEP.ClickMode.default;
    private selectedTemplate: PEP.EmploymentType;
    private customTemplate: PEP.EmploymentTemplate = null;
    private _previousSelectedTemplate: PEP.EmploymentTemplate;
    private _previousClickMode: PEP.ClickMode = PEP.ClickMode.default;
    private _isCreateMode: boolean = false; // aus den 3 Flags errechnen sich alle Modi: default/create/brush/brushcreate/delete
    private _isBrushMode: boolean = false;
    private _isDeleteMode: boolean = false;
    private _isCostUnitMode: boolean = false;
    private _isNotesMode: boolean = false;

    private customTemplateActive: boolean = false;


    private _currentFilterSettings: string = "";
    private _currentFilterSettingsApplied: string = "";
    private isDirty: boolean = false;
    private _isRequestActive: boolean = false;
    private _currentStartIndex: number = 0;
    private _maxResultCount: number = 1000;

    private _table: MdsLax<InstanceType<typeof PepTable>> = null;

    private _isRegistryLoaded: boolean = false;
    private _isFilterResultLoaded: boolean = false;


    private lastResponse: PEP.AxisResponse = null;

    //filterpanels: Array<FilterPanel>;
    private filterpanel: MdsLax<InstanceType<typeof FilterPanelWidget>>;

    private _filterOptionCW: MdsLax<InstanceType<typeof FilterPanelOption>> = null;
    private _filterOptionName: MdsLax<InstanceType<typeof FilterPanelOption>> = null;
    private _filterOptionContracts: MdsLax<InstanceType<typeof FilterPanelOption>> = null;

    private _timeout: number = null;
    private windowEx: PEP.WindowEx;

    private prepareFilteroptions(data: FilterPanelTypes.PanelConfig) {

        this.UiModder.domConstruct.empty(this.filterPanelContainer);

        let fp = new FilterPanelWidget();
        this.filterpanel = fp;
        this.filterpanel.on("serializedData", lang.hitch(this, this.checkDirtyState_delayed));

        fp.placeAt(this.filterPanelContainer);
        fp.setSectionData(data.sections);

        this._filterOptionCW = this.filterpanel.getFilterOptionByName("calendarWeek");
        this._filterOptionContracts = this.filterpanel.getFilterOptionByName("contractDispGrp");
        this._filterOptionName = this.filterpanel.getFilterOptionByName("contractByName");



        // einmalig zu Beginn serialisieren
        this.filterpanel.getData();

        // layouteinstellungen
        let inputModeSelect = new SelectBox();
        inputModeSelect.addEntry("default", "Standard");
    }

    private prepareEmploymenttypeTemplates(): void {
        if (this.templateSelect != null) {
            this.templateSelect.destroy();
            this.templateSelect = null;
        }

        //console.log("prepareEmploymenttypeTemplates", window.PepRegistry);

        this.templateSelect = new SelectBox();
        this.UiModder.domConstruct.place(this.templateSelect.domNode, this.selectTemplateContainer);

        //this.templateSelct.setLabel("xyz");

        this.templateSelect.setBlankOption("PEP_Section_Tools_SelectTypeTemplateBlank");
        for (let key in this.windowEx.PepRegistry.employmentTypes) {
            let empltype = this.windowEx.PepRegistry.employmentTypes[key];
            this.templateSelect.addOption(empltype.ID, empltype.description, true, empltype.coloration?.BackColor?.Hex, empltype.coloration?.TextColor?.Hex);
        }

        this.templateSelect.constructOptions();

        on(this.templateSelect, "change", lang.hitch(this, this._onChange_SelectEmploymentTemplate));
    }

    private prepareLayoutSettings(): void {


        this._onChange_DisplaySettings();
    }

    private _onChange_SelectEmploymentTemplate(newValue: string) {

        let type: PEP.EmploymentType = null;
        if (newValue) type = this.windowEx.PepRegistry.employmentTypes[newValue];
        this.setEmploymentTypeTemplate(<PEP.EmploymentTemplate>type);

        //console.log("_onChange_EmploymentTemplate", newValue);
        //    for (let type of window.PepRegistry.employmentTypes) {
        //        if (type.ID == newValue) {
        //            this.setEmploymentTypeTemplate(<PEP.EmploymentTemplate>type);
        //            break;
        //        }
        //    }
    }

    private _onChange_DisplaySettingsGeneral(newValue: boolean) {
        this._onChange_DisplaySettings();
    }

    private _onChange_DisplaySettingsEntityview() {
        this._onChange_DisplaySettings();

        // und jetzt müsste die bereits geladene Tabelle sich ihre Tabellenköpfe neu laden...
        if (this._table) {
            this._table.updateXaxisDescriptors();
        }
    }
    private _onChange_DisplaySettings() {
        if (!this.windowEx.DisplaySettings) return; // noch zu früh
        // von allen 3 die Werte ziehen und neu ins this.windowEx schreiben:
        let selectedTableLayout = this.cbDisplayCompact.getValue() == true ? PEP.DspTableLayoutSettings.compact : PEP.DspTableLayoutSettings.default;
        let selectedSmallInfo = this.cbDisplayValuesInSmallInfo.getValue() == true ? PEP.DspSmallInfoSettings.values : PEP.DspSmallInfoSettings.bookingStatus;

        this.windowEx.DisplaySettings.mainLabel = PEP.DspMainLabelSettings.default;
        this.windowEx.DisplaySettings.smallInfo = <PEP.DspSmallInfoSettings>selectedSmallInfo;
        this.windowEx.DisplaySettings.tableLayout = <PEP.DspTableLayoutSettings>selectedTableLayout;

        this._expandCellWidthToDisplay();

        this.windowEx.DisplaySettings.displayDayNotesInTableHeader = this.cbDisplayDayNotesInHeader.getValue() == true;
        this.windowEx.DisplaySettings.displayDayDescriptionInTableHeader = this.cbDisplayDayDescriptionInHeader.getValue() == true;
        this.windowEx.DisplaySettings.displaySpecialNotesInTableHeader = this.cbDisplaySpecialNotesInHeader.getValue() == true;

        this.windowEx.DisplaySettings.dayHeaderEntityviewLabelVariant = this.rgDayHeaderEntityviewLabelVariant.getValue();

        // bei kompakt gewähltem Tabellenlayout fällt einiges weg:
        this.windowEx.DisplaySettings.displayDayRecordSums = this.windowEx.DisplaySettings.tableLayout != PEP.DspTableLayoutSettings.compact;
        this.windowEx.DisplaySettings.displayMainLabel = this.windowEx.DisplaySettings.tableLayout != PEP.DspTableLayoutSettings.compact;
        this.windowEx.DisplaySettings.displayEmploymentValues = this.windowEx.DisplaySettings.tableLayout != PEP.DspTableLayoutSettings.compact
            && this.windowEx.DisplaySettings.smallInfo == PEP.DspSmallInfoSettings.values;
        this.windowEx.DisplaySettings.displayBookingStatus = this.windowEx.DisplaySettings.tableLayout != PEP.DspTableLayoutSettings.compact
            && this.windowEx.DisplaySettings.smallInfo == PEP.DspSmallInfoSettings.bookingStatus;

        this.applyDisplaySettingStyles();
    }

    private applyDisplaySettingStyles(): void {
        if (this._table == null) return;

        //this.showToast("neue Settings anwenden....", "displaysettings", 2500, toasterIcons.warning);
        //console.info("displaysettings", this.windowEx.DisplaySettings);

        this.removeUrlParameter(PEP.UrlParameter.displayCompactMode);
        this.removeUrlParameter(PEP.UrlParameter.displayEmploymentValues);
        this.removeUrlParameter(PEP.UrlParameter.displaySpecialNotesInHeader);
        this.removeUrlParameter(PEP.UrlParameter.displayDayNotesInHeader);
        this.removeUrlParameter(PEP.UrlParameter.displayDayDescriptionInHeader);

        let useUrlParams = FeatureHelpers.hasFeature("PEP/useUrlParams");


        this.UiModder.domClass.remove(this._table.domNode,
            " hideDayRecord" +
            " hideEmploymentMainLabel" +
            " hideEmploymentValues" +
            " hideEmploymentBookingStatus" +
            " hideEmploymentNotes");

        this.UiModder.domClass.remove(this._table.stickyHeader,
            " hideSpecialNotesInHeader" +
            " hideDayDescriptionInHeader" +
            " hideDayNotesInHeader");

        this.UiModder.domClass.remove(this._table.domNode, "compact");

        if (this.windowEx.DisplaySettings.tableLayout == PEP.DspTableLayoutSettings.compact) {
            this.UiModder.domClass.add(this._table.domNode, "compact");
            useUrlParams == true ? this.setUrlParameter(PEP.UrlParameter.displayCompactMode, "1") : null;
        }

        //this._table.redrawEmployments();
        if (this.windowEx.DisplaySettings.displayDayRecordSums != true) {
            this.UiModder.domClass.add(this._table.domNode, "hideDayRecord");

        }

        if (this.windowEx.DisplaySettings.displayEmploymentValues != true) {
            this.UiModder.domClass.add(this._table.domNode, "hideEmploymentValues");
        } else {
            useUrlParams == true ? this.setUrlParameter(PEP.UrlParameter.displayEmploymentValues, "1") : null;
        }
        if (this.windowEx.DisplaySettings.displayBookingStatus != true) {
            this.UiModder.domClass.add(this._table.domNode, "hideEmploymentBookingStatus");
        }

        if (this.windowEx.DisplaySettings.displayDayNotesInTableHeader != true) {
            this.UiModder.domClass.add(this._table.stickyHeader, "hideDayNotesInHeader");
            useUrlParams == true ? this.setUrlParameter(PEP.UrlParameter.displayDayNotesInHeader, "0") : null;
        }

        if (this.windowEx.DisplaySettings.displayDayDescriptionInTableHeader != true) {
            this.UiModder.domClass.add(this._table.stickyHeader, "hideDayDescriptionInHeader");
            useUrlParams == true ? this.setUrlParameter(PEP.UrlParameter.displayDayDescriptionInHeader, "0") : null;
        }

        if (this.windowEx.DisplaySettings.displaySpecialNotesInTableHeader != true) {
            this.UiModder.domClass.add(this._table.stickyHeader, "hideSpecialNotesInHeader");
            useUrlParams == true ? this.setUrlParameter(PEP.UrlParameter.displaySpecialNotesInHeader, "0") : null;
        }

        if (this.windowEx.DisplaySettings.displayMainLabel != true) {
            this.UiModder.domClass.add(this._table.domNode, "hideEmploymentMainLabel");
        }


        this.windowEx.DisplaySettings.displayNoteInGrid = this.cbDisplayNoteInGrid.getValue();
        //console.debug("displaysettings table notes in grid", this._table.domNode, this.windowEx.DisplaySettings.displayNoteInGrid != true);
        if (this.windowEx.DisplaySettings.displayNoteInGrid != true) {
            this.UiModder.domClass.add(this._table.domNode, "hideEmploymentNotes");
        }

        this._table.recalcRowHeights();
        this._table.recalcColumnWidths();

    }

    setEmploymentTypeTemplate(type: PEP.EmploymentTemplate) {
        this.selectedTemplate = type;
        this.windowEx.CurrentSelectedEmploymentTypeTemplate = type;

        if (this.selectedTemplate) {
            this.removeToast("brushMode_noTemplate");
            //this.txtTemplateInfoStart.innerHTML = type.startTXT;
            //this.txtTemplateInfoEnd.innerHTML = type.endTXT;
            //this.txtTemplateInfoBreak.innerHTML = type.pause_duration_default.toFixed(2);
            //this.UiModder.domStyle.set(this.templateInfoContainer, "backgroundColor", type.coloration.BackColor.Hex);
            this.templateInfoContainer.style.setProperty("--colorBG", type.coloration?.BackColor?.Hex);
            this.templateInfoContainer.style.setProperty("--colorTXT", type.coloration?.TextColor?.Hex);


            this.txtTemplateLabel.innerHTML = type.mainLabel;
            this.txtTemplateEmploymentType.innerHTML = type.code;
            this.txtTemplateValue1.innerHTML = type.value1;
            this.txtTemplateValue2.innerHTML = type.value2;

            this.UiModder.domClass.remove(this.templateInfoContainer, "invisible");

            //if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brush) {
            //    this.setClickModeStyles();
            //} else {
            //    this.switchClickMode(PEP.ClickMode.brushCreate);
            //}

        } else {
            this.UiModder.domClass.add(this.templateInfoContainer, "invisible");
            if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brush) {

                this.switchClickMode(PEP.ClickMode.default);
            }
        }

    }

    getSelectedEmploymentTypeTemplate(): PEP.EmploymentType {
        return this.selectedTemplate;
    }

    private _checkUrlParams(): boolean {
        let calendarWeekID = this.getUrlParameterValue(PEP.UrlParameter.calendarWeek);
        let rawcontractID = this.getUrlParameterValue(PEP.UrlParameter.contractDispGroup);
        let contractByName = this.getUrlParameterValue(PEP.UrlParameter.contractByName);
        let target = this.getUrlParameterValue(PEP.UrlParameter.targetID);
        let targetType = this.getUrlParameterValue(PEP.UrlParameter.targetType);

        let useUrlParams = FeatureHelpers.hasFeature("PEP/useUrlParams");


        if (useUrlParams == true) {

            let changeEvent: boolean = false;
            let dsp = this.getUrlParameterValue(PEP.UrlParameter.displayCompactMode);
            if (dsp !== false) {
                this.cbDisplayCompact.setValue(dsp === "1", true);
                changeEvent = true;
            }

            dsp = this.getUrlParameterValue(PEP.UrlParameter.displayEmploymentValues);
            if (dsp !== false) {
                this.cbDisplayValuesInSmallInfo.setValue(dsp === "1", true)
                changeEvent = true;
            }

            dsp = this.getUrlParameterValue(PEP.UrlParameter.displaySpecialNotesInHeader);
            if (dsp !== false) {
                this.cbDisplaySpecialNotesInHeader.setValue(dsp === "1", true)
                changeEvent = true;
            }

            dsp = this.getUrlParameterValue(PEP.UrlParameter.displayDayNotesInHeader);
            if (dsp !== false) {
                this.cbDisplayDayNotesInHeader.setValue(dsp === "1", true)
                changeEvent = true;
            }

            dsp = this.getUrlParameterValue(PEP.UrlParameter.displayDayDescriptionInHeader);
            if (dsp !== false) {
                this.cbDisplayDayDescriptionInHeader.setValue(dsp === "1", true)
                changeEvent = true;
            }

            if (changeEvent == true) {
                this._onChange_DisplaySettings();
            }
        }

        else {
            calendarWeekID = false;

            this.removeUrlParameter(PEP.UrlParameter.displaySpecialNotesInHeader);
            this.removeUrlParameter(PEP.UrlParameter.displayCompactMode);
            this.removeUrlParameter(PEP.UrlParameter.displayDayNotesInHeader);
            this.removeUrlParameter(PEP.UrlParameter.displayDayDescriptionInHeader);
            this.removeUrlParameter(PEP.UrlParameter.displayEmploymentValues);
            this.removeUrlParameter(PEP.UrlParameter.targetID);
            this.removeUrlParameter(PEP.UrlParameter.targetType);
        }

        //console.debug("_checkUrlParams - cw - contract - name - target", calendarWeekID, rawcontractID, contractByName, target, targetType);

        if (calendarWeekID === false || rawcontractID === false) {
            this.removeUrlParameter(PEP.UrlParameter.calendarWeek);
            this.removeUrlParameter(PEP.UrlParameter.contractDispGroup);
            this.removeUrlParameter(PEP.UrlParameter.contractByName);
            this.removeUrlParameter(PEP.UrlParameter.targetID);
            this.removeUrlParameter(PEP.UrlParameter.targetType);
            this.UiModder.domClass.remove(this.filterSection, "w3-hide");
            this.UiModder.domClass.add(this.urlForwardingContainer, "w3-hide hide");
            this.UiModder.domClass.remove(this.pepTableContainer, "hide");
            return false;
        }

        this.UiModder.domClass.add(this.filterSection, "w3-disabled w3-hide");
        this.UiModder.domClass.add(this.displaySettingsSection, "w3-disabled w3-hide");
        this.UiModder.domClass.remove(this.urlForwardingContainer, "w3-hide");

        setTimeout(lang.hitch(this, function () { this.UiModder.domClass.remove(this.urlForwardingContainer, "hide"); }), 10);


        let contractID: string = <string>rawcontractID;

        let contractIDs: Array<string> = contractID.split(",");

        let data = {
            "urlParams": true,
            "calendarWeek": calendarWeekID,
            "contractDispGrp": contractIDs,
            "contractByName": contractByName != false ? contractByName : ""
        };

        this._isFilterResultLoaded = false;
        this.loadAxisDescriptors(data);

        return true;
    }

    loadBaseRegistry(): void {
        this.StandbyStart();

        // außerdem eine Instanz des Editor vorbereiten
        //let editor = new PepEmploymentEditor();
        ////editor.startup();
        //this.windowEx.PepEmploymentEditor = editor;

        var url = this.windowEx.appRoot + "Pep/GetBaseRegistry";


        this.RequestManager.post(
            url,
            {
                jsonData: null
            },
            lang.hitch(this, this._onLoadBaseRegistryResponse),
            lang.hitch(this, this._onLoadBaseRegistryError),
            false // sync
        );



    }

    private _onLoadBaseRegistryResponse(response: any) {
        this.StandbyStop();

        console.info("_onLoadBaseRegistryResponse", response);

        //this.windowEx.registry = <PepRegistry>{ employmentTypes: response.employmentTypes, taskDefinitions: response.taskDefinitions };
        this.windowEx.PepRegistry = {
            defaultEmploymentBookingStatus: response.defaultEmploymentBookingStatus,
            employmentBookingStatus: {},
            employmentTypes: {},
            taskDefinitions: {}
        };

        // registry sind jetzt records, d.h. die Arrays aus der API übersetzen:
        if (response.employmentBookingStatus?.length) {
            for (let entity of response.employmentBookingStatus) {
                this.windowEx.PepRegistry.employmentBookingStatus[entity.ID] = entity;
            }
        }
        if (response.employmentTypes?.length) {
            for (let entity of response.employmentTypes) {
                this.windowEx.PepRegistry.employmentTypes[entity.ID] = entity;
            }
        }
        if (response.taskDefinitions?.length) {
            for (let entity of response.taskDefinitions) {
                this.windowEx.PepRegistry.taskDefinitions[entity.ID] = entity;
            }
        }

        this._isRegistryLoaded = true;
        this._continueWithTable(this.lastResponse);
        topic.publish("PEP/RegistryLoaded");

        this.prepareEmploymenttypeTemplates();
        this.prepareLayoutSettings();
    }

    private _onLoadBaseRegistryError(error: any) {

        this.StandbyStop();

        //alert("Registry konnte nicht geladen werden: " + error.Message);
        this.showError("Registry konnte nicht geladen werden: " + error.Message);
    }

    loadFilterOptions(): void {
        if (!this._isRequestActive) this.StandbyStart();

        let url = this.windowEx.appRoot + "Pep/GetFilterpanelOptions";

        this.RequestManager.post(
            url,
            {
                jsonData: null
            },
            lang.hitch(this, this._onLoadFilterOptionsResponse),
            lang.hitch(this, this._onLoadFilterOptionsError),
            false // sync
        );
    }

    private _onLoadFilterOptionsResponse(response: any) {
        this.StandbyStop();

        console.log("_onLoadFilterOptionsResponse", response);

        let filteropt: FilterPanelTypes.PanelConfig = response.filterPanelRoot;

        this.prepareFilteroptions(filteropt);

        let isLoading = this._isRequestActive || this._isFilterResultLoaded;

        if (!isLoading) {

            this.UiModder.domClass.remove(this.filterSection, "hide");
            this.hideNode(this.displaySettingsSection, false);
        }
    }

    private _onLoadFilterOptionsError(error: any) {

        this.StandbyStop();

        this.showErrorDetailsDlg(error.Message, this.translations["PEP_Section_Filter"], null, "ok", null);

        //alert("Filteroptionen können nicht geladen werden: " + error.Message);
    }

    checkDirtyState_delayed(result: boolean): void {

        // bestehendes Event unterbrechen
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        this._timeout = setTimeout(lang.hitch(this, this.checkDirtyState, result), 100);
    }

    private checkDirtyState(bForceFalse?: false): void {
        //console.debug("checkDirtyState");

        if (bForceFalse === false) {
            this.set("dirty", false);
            return;
        }
        if (!this.filterpanel) return;

        let json = { sections: this.filterpanel.getData() };//, currentStartIndex: this._currentStartIndex, limit: this._maxResultCount };
        let bValid = this.filterpanel.valid;

        let jsonString = JSON.stringify(json)
        this._currentFilterSettings = jsonString;

        let bIsDirty = this._currentFilterSettingsApplied != this._currentFilterSettings && bValid === true;

        this.set("dirty", bIsDirty);

    }

    private _setDirtyAttr(value?: boolean) {


        this.isDirty = value === true;

        //console.debug("setDirty", this.isDirty);

        this.setSubmitButtonStyle();
    }

    private setSubmitButtonStyle(overrideEnable?: boolean): void {

        //console.debug("setSubmitButtonStyle", this.isDirty, endOfList, this._completeList.length, this.lastResponse.totalResultCount);


        let classesEnabled: string = "accentBG hoverBright";
        let classesDisabled: string = "w3-disabled tertiaryBG";

        this.UiModder.domClass.remove(this.btnSubmit, classesDisabled);
        this.UiModder.domClass.remove(this.btnSubmit, classesEnabled);

        let bEnable = (this.isDirty == true) && this._isRequestActive != true;
        if (overrideEnable === true || overrideEnable === false) bEnable = overrideEnable;

        this.UiModder.domClass.toggle(this.btnSubmit, classesEnabled, bEnable);
        this.UiModder.domClass.toggle(this.btnSubmit, classesDisabled, !bEnable);


        this.UiModder.domAttr.set(this.btnSubmitLabel, "innerHTML", this.translations["PEP_Home_SubmitButtonLabel"]);
    }

    private _onClick_Submit(evt: Event) {
        if (this._isRequestActive === true || (this.isDirty != true)) {
            return;
        }

        if (this._table != null) {
            if (this._table.isDirty == true) {
                if (confirm(this.translations["PEP_warning_pendingChanges"]) != true) {
                    return;
                }
            }
        }

        // irgendwie erzwingen, dass alle Steuerelemente ihren jetzt aktuellen Wert hergeben!
        this.filterpanel.getData();


        this.UiModder.domClass.add(this.filterSection, "w3-disabled");

        try {
            if (this.settingsDlg != null) {
                this.settingsDlg.close(1);
                this.settingsDlg = null;
            }
        } catch (ex) {
            if (this.settingsDlg && this.settingsDlg._destroyed) {
                this.settingsDlg = null;
            }
        }
        this._isFilterResultLoaded = false;

        this.loadAxisDescriptors();
    }

    private _onClick_ModeDefault(evt: MouseEvent) {
        //this._isCreateMode = true; // der Defaultbutton ist sichtbar und wird geklickt -> wechselt zum Plus-Button
    }

    private _onClick_ModeEdit(evt: MouseEvent) {
        // nix!
    }

    private _onClick_ModeCostUnit(evt: MouseEvent) {

        this._isCostUnitMode = !this._isCostUnitMode;

        if (this._isCostUnitMode) {
            // create ist nicht erlaubt
            this._isCreateMode = false;

            // standardmäßig kommt der Pinselmodus dazu
            if (!this._isDeleteMode && !this._isBrushMode) {
                this._isBrushMode = true;
            }
        }

        else {
            // Pinsel auch ausschalten falls "ungültig"
            if (this._isBrushMode) {
                if (!this._clickModeValidation(PEP.ClickMode.brush, true)) {
                    this._isBrushMode = false;
                }
            }
        }

        this.switchClickMode();
    }

    private _onClick_ModeAdd(evt: MouseEvent) {

        if (this._isCostUnitMode) { // im Kostenträgermodus nicht zugelassen
            return;
        }

        if (this._isDeleteMode) {
            this._isCreateMode = true;
        } else {
            this._isCreateMode = !this._isCreateMode;
        }
        this._isDeleteMode = false;
        this.switchClickMode();
    }

    private _onClick_ModeCellNotes(evt: MouseEvent) {
        if (this._isNotesMode) {
            this.switchClickMode(this._previousClickMode);
        } else {
            this.switchClickMode(PEP.ClickMode.cellNotes);
        }
    }

    private _onClick_ModeBrush(evt: MouseEvent) {

        if (!this._isBrushMode) {
            if (!this._clickModeValidation(PEP.ClickMode.brush)) {
                return;
            }
        }


        if (this._isDeleteMode) {
            this._isBrushMode = true;
        } else {
            this._isBrushMode = !this._isBrushMode;
        }


        // falls Kostenträgermodus: diesen ausschalten (der geht nur mit Pinsel oder Delete)
        if (this._isCostUnitMode) {
            if (!this._isBrushMode && !this._isDeleteMode) {
                this._isCostUnitMode = false;
            }
            else {
                this._isDeleteMode = false;
            }
        } else {
            this._isDeleteMode = false;
        }

        this.switchClickMode();

    }

    private _onClick_ModeDelete(evt: MouseEvent) {
        this._isDeleteMode = !this._isDeleteMode;

        // falls Kostenträgermodus: diesen ausschalten (der geht nur mit Pinsel oder Delete)
        if (this._isCostUnitMode) {
            if (!this._isBrushMode && !this._isDeleteMode) {
                this._isCostUnitMode = false;
            }
        }

        if (!this._isDeleteMode) {
            this.switchClickMode(this._previousClickMode);
            return;
        }

        this.switchClickMode();
    }

    private _onClickCancelCustomTemplate(evt: MouseEvent) {
        evt.stopPropagation();

        if (this.customTemplateActive != true) {
            return;
        }

        this.setCustomTemplateMode(false);
    }

    private _clickModeValidation(newMode: PEP.ClickMode, bSilent?: boolean): boolean {
        if (this._isCostUnitMode) {
            return true;
        }
        if ((newMode == PEP.ClickMode.brush || newMode == PEP.ClickMode.brushCreate)
            && this.windowEx.CurrentSelectedEmploymentTypeTemplate == null) {
            if (bSilent !== true) {
                this.showToast({
                    title: this.translations["PEP_Message_BrushMode_NoTemplate_Short"],
                    options: {
                        ID: "brushMode_noTemplate",
                        timeout: 10000
                    }, iconClass: ToasterHelpers.ToasterIcons.warning
                });
                this.UiModder.domClass.add(this.selectTemplateContainer, "mds-shake");
                setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.selectTemplateContainer, "mds-shake"), 1000);
            }

            return false;
        }

        return true;
    }

    setCustomTemplateMode(templateData: PEP.EmploymentTemplate | false) {

        console.debug("setCustomTemplateMode", templateData);

        if (!templateData) {
            this.customTemplateActive = false;
            this._isBrushMode = this._previousClickMode == PEP.ClickMode.brush || this._previousClickMode == PEP.ClickMode.brushCreate;
            this._isDeleteMode = this._previousClickMode == PEP.ClickMode.delete;
            this._isCreateMode = this._previousClickMode == PEP.ClickMode.create || this._previousClickMode == PEP.ClickMode.brushCreate;
            this._isCostUnitMode = this._previousClickMode == PEP.ClickMode.brushCostUnit || this._previousClickMode == PEP.ClickMode.deleteCostUnit;

            this.setEmploymentTypeTemplate(this._previousSelectedTemplate);
            this._previousClickMode = null;

            this.switchClickMode();
        }
        else {
            this._previousSelectedTemplate = this.windowEx.CurrentSelectedEmploymentTypeTemplate;
            this._previousClickMode = this.windowEx.CurrentSelectedClickMode;
            this.customTemplateActive = true;
            this._isBrushMode = true;
            this._isDeleteMode = false;
            this._isCreateMode = false;
            this.customTemplate = templateData;
            this.setEmploymentTypeTemplate(this.customTemplate);

            this.switchClickMode(PEP.ClickMode.customBrush);
        }


    }

    switchClickMode(newMode?: PEP.ClickMode) {

        // errechnen was der neue Modus ist
        if (!newMode) {
            newMode = PEP.ClickMode.default;

            this._isNotesMode = false;

            if (this.customTemplateActive) {
                newMode = PEP.ClickMode.customBrush;
            }

            if (this._isDeleteMode == true) {
                newMode = PEP.ClickMode.delete;
                this._isBrushMode = false;
                this._isCreateMode = false;

                if (this._isCostUnitMode == true) {
                    newMode = PEP.ClickMode.deleteCostUnit;
                }
            }

            else if (this._isCreateMode) { // Create aktiv
                if (this._isBrushMode) {
                    newMode = PEP.ClickMode.brushCreate;
                } else {
                    newMode = PEP.ClickMode.create;
                }
            } else { // Create nicht aktiv - "Editmodus"
                if (this._isBrushMode) {
                    newMode = PEP.ClickMode.brush;

                    if (this._isCostUnitMode) {
                        newMode = PEP.ClickMode.brushCostUnit;
                    }
                } else {
                    newMode = PEP.ClickMode.default;
                }
            }
        }

        else {
            this._isBrushMode = newMode == PEP.ClickMode.brush ||
                newMode == PEP.ClickMode.brushCostUnit ||
                newMode == PEP.ClickMode.brushCreate ||
                newMode == PEP.ClickMode.customBrush;
            this._isCostUnitMode = newMode == PEP.ClickMode.brushCostUnit ||
                newMode == PEP.ClickMode.deleteCostUnit;
            this._isCreateMode = newMode == PEP.ClickMode.brushCreate ||
                newMode == PEP.ClickMode.create;
            this._isDeleteMode = newMode == PEP.ClickMode.delete ||
                newMode == PEP.ClickMode.deleteCostUnit;

            this._isNotesMode = newMode == PEP.ClickMode.cellNotes;
        }
        //console.debug("switchClickMode", newMode);

        if (newMode == PEP.ClickMode.customBrush) {
            this.customTemplateActive = true;
            newMode = PEP.ClickMode.brush; // verhält sich dann wie normaler Pinsel
        }

        this._previousClickMode = this.clickmode;

        this.clickmode = newMode;
        this.windowEx.CurrentSelectedClickMode = newMode;
        this.setClickModeStyles();
    }

    getSelectedClickMode(): PEP.ClickMode {
        return this.clickmode;
    }

    private setClickModeStyles(): void {
        this.UiModder.domClass.remove(this.btnModeNotes, "selected cL5 w3-disabled w3-hide");
        this.UiModder.domClass.remove(this.btnModeBrush, "selected accentBG w3-disabled w3-hide");
        //this.UiModder.domClass.remove(this.btnModeCostUnit, "selected accentBG w3-disabled w3-hide");
        this.UiModder.domClass.remove(this.btnModeAdd, "selected accentBG w3-disabled w3-hide");
        //this.UiModder.domClass.remove(this.btnModeDefault, "selected accentBG w3-hide w3-hide");
        //this.UiModder.domClass.remove(this.btnModeEdit, "selected accentBG w3-hide w3-hide");
        this.UiModder.domClass.remove(this.btnModeDelete, "selected accentBG");
        this.UiModder.domClass.add(this.iconBrushPlus, "w3-hide");
        this.UiModder.domClass.remove(this.templateInfoContainer, "w3-disabled");
        this.UiModder.domClass.remove(this.templateInfoFlexRow, "w3-hide");


        //custom-brush-modus
        let fct1 = this.UiModder.domClass.add;
        let fct2 = this.UiModder.domClass.remove;
        let borderColor = "";

        if (this.customTemplateActive) {
            fct1 = this.UiModder.domClass.remove;
            fct2 = this.UiModder.domClass.add;
            borderColor = "var(--primary)";
        }

        fct1(this.cancelCustomTemplateContainer, "w3-hide");
        fct2(this.selectTemplateContainer, "w3-hide");
        fct2(this.btnModeBrush, "w3-disabled");
        fct2(this.btnModeNotes, "w3-disabled");
        fct2(this.btnModeDelete, "w3-disabled");
        fct2(this.btnModeDefault, "w3-disabled");
        fct2(this.btnModeEdit, "w3-disabled");
        fct2(this.btnModeCostUnit, "w3-disabled");

        this.UiModder.domStyle.set(this.templateInfoContainer, "borderColor", borderColor);

        if (this.selectedTemplate == null) {
            //this.UiModder.domClass.add(this.btnModeBrush, "w3-disabled");
        }

        if (this._table != null) {
            this.UiModder.domClass.remove(this._table.domNode, "defaultMode deleteMode deleteCostUnitMode notesMode brushMode brushCreateMode brushCostUnitMode createMode");

            let selectedClasses = "accentBG selected";

            switch (this.clickmode) {
                case PEP.ClickMode.default:
                    this.UiModder.domClass.add(this._table.domNode, "defaultMode");
                    break;

                case PEP.ClickMode.brush:
                    // nur brush-Button
                    this.UiModder.domClass.add(this._table.domNode, "brushMode");

                    this.UiModder.domClass.add(this.btnModeBrush, selectedClasses);

                    break;
                case PEP.ClickMode.cellNotes:
                    // nur notes-Button
                    this.UiModder.domClass.add(this._table.domNode, "notesMode");

                    this.UiModder.domClass.add(this.btnModeNotes, selectedClasses);

                    break;

                case PEP.ClickMode.brushCreate:
                    this.UiModder.domClass.add(this._table.domNode, "brushCreateMode");
                    //this.UiModder.domClass.remove(this.iconBrushPlus, "w3-hide");

                    // plus und brush aktiv
                    this.UiModder.domClass.add(this.btnModeBrush, selectedClasses);
                    this.UiModder.domClass.add(this.btnModeAdd, selectedClasses);

                    break;

                case PEP.ClickMode.brushCostUnit:
                    this.UiModder.domClass.add(this._table.domNode, "brushCostUnitMode");
                    //this.UiModder.domClass.remove(this.iconBrushPlus, "w3-hide");

                    // kostenträger und brush aktiv
                    this.UiModder.domClass.add(this.btnModeBrush, selectedClasses);
                    this.UiModder.domClass.add(this.btnModeCostUnit, selectedClasses);

                    // plus inaktiv, darf nicht gewählt werden
                    this.UiModder.domClass.add(this.btnModeAdd, "w3-disabled");

                    this.UiModder.domClass.add(this.templateInfoFlexRow, "w3-hide");

                    break;

                case PEP.ClickMode.deleteCostUnit:
                    this.UiModder.domClass.add(this._table.domNode, "deleteCostUnitMode");
                    //this.UiModder.domClass.remove(this.iconBrushPlus, "w3-hide");

                    // kostenträger und brush aktiv
                    this.UiModder.domClass.add(this.btnModeDelete, selectedClasses);
                    this.UiModder.domClass.add(this.btnModeCostUnit, selectedClasses);

                    // plus inaktiv, darf nicht gewählt werden
                    this.UiModder.domClass.add(this.btnModeAdd, "w3-disabled");

                    this.UiModder.domClass.add(this.templateInfoFlexRow, "w3-hide");

                    break;

                case PEP.ClickMode.create:
                    this.UiModder.domClass.add(this._table.domNode, "createMode");

                    // nur plus aktiv
                    this.UiModder.domClass.add(this.btnModeAdd, selectedClasses);

                    break;

                case PEP.ClickMode.delete:
                    this.UiModder.domClass.add(this._table.domNode, "deleteMode");

                    // nur delete aktiv
                    this.UiModder.domClass.add(this.btnModeDelete, selectedClasses);
                    this.UiModder.domClass.add(this.templateInfoContainer, "w3-disabled");

                    // anderes darf nicht gewählt werden:
                    this.UiModder.domClass.add(this.btnModeAdd, "w3-disabled");
                    this.UiModder.domClass.add(this.btnModeBrush, "w3-disabled");

                    break;
            }
        }


    }

    private loadAxisDescriptors(overrideData: Object = null): void {

        this.removeToast("resultinfo");

        this.StandbyStart(this.pepTableContainer);
        var url = this.windowEx.appRoot + "Pep/GetAxisDescriptors";
        this._isRequestActive = true;
        this.setSubmitButtonStyle();
        let data: any = null;

        if (typeof (overrideData) == "undefined" || overrideData == null) {
            data = JSON.parse(this._currentFilterSettings);
        } else {
            //console.debug("getAxisDescriptors", overrideData);
            data = overrideData;
        }

        data.displaySettings = this.windowEx.DisplaySettings;

        data.limit = this._maxResultCount;
        data.currentStartIndex = this._currentStartIndex;
        var stringData = JSON.stringify(data);


        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onGetAxisDescriptorsResult, this._currentFilterSettings),
            lang.hitch(this, this._onGetAxisDescriptorsError),
            false // sync
        );
    }
    private _onGetAxisDescriptorsResult(currentFiltersettings: string, response: PEP.AxisResponse) {

        this.StandbyStop();
        this._isRequestActive = false;
        this._currentFilterSettingsApplied = currentFiltersettings;

        this.UiModder.domClass.remove(this.filterSection, "w3-disabled w3-hide");
        this.UiModder.domClass.remove(this.displaySettingsSection, "w3-disabled w3-hide");
        this.UiModder.domClass.add(this.urlForwardingContainer, "hide");

        if (response.yDescriptors.length == 0 || response.xDescriptors.length == 0) {
            this.showToast({
                title: this.translations["PEP_Home_noFilterResults"],
                options: {
                    ID: "PEP_Home_noFilterResults",
                    //    timeout: 5000
                },
                iconClass: ToasterHelpers.ToasterIcons.info
            });


            this.removeUrlParameter(PEP.UrlParameter.calendarWeek);
            //this.removeUrlParameter(PEP.UrlParameter.contractDispGroup);
            this.removeUrlParameter(PEP.UrlParameter.contractByName);
            this.removeUrlParameter(PEP.UrlParameter.targetID);
            this.removeUrlParameter(PEP.UrlParameter.targetType);

            return;
        }

        this._isFilterResultLoaded = true;

        this.showError(false);

        this.lastResponse = response;

        this._continueWithTable(this.lastResponse);

        console.debug("_onGetAxisDescriptorsResult", response);

        this.checkDirtyState();
    }

    private _continueWithTable(data: PEP.AxisResponse) {

        if (this._isRegistryLoaded != true || this._isFilterResultLoaded != true) {
            return;
        }

        // wohin kommen die Elemente normalerweise (beim Laden der Tabelle)? Welche Klassen werden entfernt und hinzugefügt?
        // falls data null ist, werden die Funktionen entsprechend umgedreht!
        let targetContainer = this.topBarContainer;

        if (data != null) {

        } else {
            targetContainer = this.hiddenSection;
        }

        this.hideNode(this.filterSection, data != null);
        if (!data) {
            this.UiModder.domClass.remove(this.filterSection, "hide");
            this._isFilterResultLoaded = false;
        }
        this.hideNode(this.displaySettingsSection, data != null);
        this.hideNode(this.pepTableSection, data == null);

        this.UiModder.domConstruct.place(this.buttonsRowContainer, targetContainer);
        //this.UiModder.domConstruct.place(this.topContainerFiller, targetContainer);
        this.UiModder.domConstruct.place(this.templateInfoFlexRow, targetContainer);

        let useUrlParams = FeatureHelpers.hasFeature("PEP/useUrlParams");



        // jetzt die PEP-Tabelle damit füttern...
        if (this._table != null) {
            this._table.destroy();
            this._table = null;
        } else if (data != null) {

            if (useUrlParams == true && this._filterOptionCW && this._filterOptionName) {
                // merken was im Filter drin war (rudimentär...)
                if (this._filterOptionCW.getValue() && this.getUrlParameterValue(PEP.UrlParameter.calendarWeek) == false) {
                    this.setUrlParameter(PEP.UrlParameter.calendarWeek, this._filterOptionCW.getValue().toString());
                }
                if (this._filterOptionName.getValue()) {
                    this.setUrlParameter(PEP.UrlParameter.contractByName, this._filterOptionName.getValue() as string);
                }

                let contracts = this._filterOptionContracts.getValue() as Array<string>;

                if (contracts?.length) {
                    this.setUrlParameter(PEP.UrlParameter.contractDispGroup, contracts.toString());
                }

            }


            this._table = new PepTable();
            this._table.startup();

            this.applyDisplaySettingStyles();

            this.UiModder.domConstruct.place(this._table.domNode, this.pepTableContainer);

            this._table.setAxisData(data.xDescriptors, data.yDescriptors, data.base);
            this._table.setWeekRecordAxisData(data.weekRecordData, true);
            this._table.drawCalendarWeekNavigation(data.navigationWeeks);

            this._recalcWidthDelayed(500);

            this.setClickModeStyles();

            this.UiModder.domClass.remove(this.pepTableContainer, "hide");
            setTimeout(lang.hitch(this, function () { this.UiModder.domClass.add(this.urlForwardingContainer, "w3-hide hide"); }), 1100);

        }
        //for (let fp of this.filterpanels) {
        //    fp.collapse();
        //}    


    }

    private _expandCellWidthToDisplay(): void {
        let documentWidth = this.windowEx.innerWidth;
        this._recalcWidthHandle = null;

        if (!this._table) return;

        if (this.windowEx.DisplaySettings.tableLayout == PEP.DspTableLayoutSettings.compact) {
            this._table.domNode.style.removeProperty("--PEPcellWidth");
            return;
        }

        let mainContent = document.getElementById("mainContent");
        if (!mainContent) return;

        try {
            let mainContentRect = mainContent.getBoundingClientRect();
            let style = this.windowEx.getComputedStyle(mainContent);
            let padding = parseFloat(style.paddingLeft)
            parseFloat(style.paddingRight);
            let actualContentWidth = mainContentRect.width - padding;
            let tableContainerWidth = parseFloat(this.windowEx.getComputedStyle(this.pepTableSection).width);
            let tableWidth = parseFloat(this.windowEx.getComputedStyle(this._table.domNode).width);
            let currentBoxWidth = parseFloat(this.windowEx.getComputedStyle(this._table.domNode)["--PEPcellWidth"]);

            currentBoxWidth = 95;

            if (tableContainerWidth < tableWidth) {
                this._table.domNode.style.setProperty("--PEPcellWidth", currentBoxWidth.toString() + "px");
                tableWidth = parseFloat(this.windowEx.getComputedStyle(this._table.domNode).width);

            }

            while (tableContainerWidth > tableWidth + 75) {

                currentBoxWidth += 10;

                this._table.domNode.style.setProperty("--PEPcellWidth", currentBoxWidth.toString() + "px");

                tableWidth = parseFloat(this.windowEx.getComputedStyle(this._table.domNode).width);

                if (currentBoxWidth > 360) {
                    break;
                }

            }

        } catch (ex) {
            console.warn("exception while calculating cell widths: " + ex);
        }

    }

    private _recalcWidthHandle: any = null;
    private _recalcWidthDelayed(timeout?: number) {
        if (this._recalcWidthHandle != null) {
            clearTimeout(this._recalcWidthHandle);
        }

        if (!timeout) {
            timeout = 900;
        }

        //console.debug(this.id + " _recalcWidthDelayed");

        this._recalcWidthHandle = setTimeout(lang.hitch(this, this._expandCellWidthToDisplay), timeout);
    }

    private _onGetAxisDescriptorsError(error: any): void {

        this.lastResponse = null;

        console.error(error);
        this.StandbyStop();
        this._isRequestActive = false;

        this.showError(error.Message);
        this.UiModder.domClass.add(this.urlForwardingContainer, "hide");

        //alert(error.message);
    }

    private showError(message: string | false, details?: string) {
        if (message === false) {
            this.UiModder.domClass.add(this.resultMessageErrorContainer, "w3-hide");
            this.UiModder.domClass.remove(this.resultMessageErrorContainer, "mds-hover-dark");
        } else {
            this.UiModder.domAttr.set(this.resultMessageError, "innerHTML", message);
            this.UiModder.domClass.remove(this.resultMessageErrorContainer, "w3-hide");

            if (typeof (details) != "undefined" && details != null) {
                //this.UiModder.domClass.add(this.resultMessageErrorContainer, "mds-hover-dark"); //?? war wohl mal klickbar gedacht
            }
        }
    }

    //removeToast(ID: string) {
    //    this.showToast(false, ID);
    //}

    //showToast(message: string | false, ID: string, timeout?: number | false | "permanent", icon?: toasterIcons, extendedMessage?: string, options?: toastOptions) {

    //    let defaultIcon: toasterIcons = toasterIcons.confirmCheck;

    //    if (message === false) {
    //        this.toaster.removeToastById(ID);
    //    }
    //    else {

    //        if (typeof (icon) != "undefined") {
    //            defaultIcon = icon;
    //        }

    //        let defaultOptions: toastOptions = {
    //            closeButton: typeof (timeout) == "undefined" ? true : false, timeout: typeof (timeout) == "number" ? timeout : -1
    //        };

    //        if (typeof (options) != "undefined" && options != null) {
    //            defaultOptions = options;
    //        }

    //        defaultOptions.ID = ID;

    //        if (timeout === false) {
    //            //defaultOptions.close = true;
    //        } else if (typeof (timeout) == "number") {
    //            defaultOptions.timeout = timeout;
    //        }
    //        else if (timeout == "permanent") {
    //            defaultOptions.timeout = timeout;
    //        } else {
    //            defaultOptions.timeout = 5000;
    //        }

    //        if (extendedMessage != null && typeof (extendedMessage) != "undefined") {
    //            defaultOptions.onClick = {
    //                callback: lang.hitch(this, this.showErrorDetailsDlg, extendedMessage, message, null, "close", null)
    //            };

    //            this.toaster.addToast(message, defaultIcon, defaultOptions);
    //        }
    //        else {
    //            this.toaster.addToast(message, defaultIcon, defaultOptions);
    //        }
    //    }
    //}

    private showErrorDetailsDlg(message, header, subtitle, buttons, callback) {
        let dlg = new GenericDialog();
        dlg.show(message, header, subtitle, null, buttons, callback);
    }

    private _onClickSettings(evt: MouseEvent) {
        evt.stopPropagation();
        this.showSettingsDlg();
    }

    private _onClick_CloseTable(evt: MouseEvent) {

        this.UiModder.domConstruct.place(this.displaySettingsContainer, this.displaySettingsSection);

        if (this._table != null) {

            if (this._table.isDirty == true) {
                if (confirm(this.translations["PEP_warning_pendingChanges"]) != true) {
                    return;
                }
            }

            this._continueWithTable(null);

            this.removeUrlParameter(PEP.UrlParameter.calendarWeek);
            this.removeUrlParameter(PEP.UrlParameter.contractDispGroup);
            this.removeUrlParameter(PEP.UrlParameter.contractByName);
            this.removeUrlParameter(PEP.UrlParameter.targetID);
            this.removeUrlParameter(PEP.UrlParameter.targetType);

            this._setDirtyAttr(this._currentFilterSettingsApplied != "");

            if (this.settingsDlg != null) {
                this.settingsDlg.close();
                this.settingsDlg = null;
            }
        }
    }

    showSettingsDlg() {

        let heading = this.translations["PEP_Section_Tools"];// + " & " + this.translations["PEP_Section_Filter"];

        let dlg = new GenericDialog();

        this.settingsDlg = dlg;

        dlg.propagateClick = false;

        dlg.addButtonEx({
            internalName: "closeTable",
            label: "PEP_Section_CloseTable",
            iconClass: "fas fa-calendar-times",
            callback: lang.hitch(this, this._onClick_CloseTable),
            bCloseOnClick: true,
            styleClass: "primary",
            //placement: "first",
            order: 900,
        });

        //dlg.addNodeToContent(this.filterContainer);
        //dlg.addNodeToContent(this.closeTableContainer);

        dlg.addNodeToContent(this.displaySettingsContainer);

        dlg.show(null, heading, null, null, "close", lang.hitch(this, this.onCloseSettingsDlg));
    }

    private onCloseSettingsDlg(result: number) {
        //console.debug("onCloseSettingsDlg", result);
        //this.UiModder.domConstruct.place(this.closeTableContainer, this.hiddenSection);
        this.UiModder.domConstruct.place(this.displaySettingsContainer, this.displaySettingsSection);
        this.settingsDlg = null;
    }

    postMixInProperties(args?: any): void {
        super.postMixInProperties.apply(this, arguments as any);

        this.windowEx = window as any;
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.handleAs = "json";
        this.windowEx.PepHome = this;
        this.windowEx.PepEmploymentEditor = null;


        // Labelvarianten für Tageskopf-Entityviews einrichten. False (aus) geht immer, falls Varianten im Modul hinterlegt: diese übernehmen
        this.rgDayHeaderEntityviewLabelVariant.addEntry(false, "General_SetAsInactive", true);
        this.rgDayHeaderEntityviewLabelVariant.setValue(false, true);
        if (FeatureHelpers.hasFeature("PEP/EntityViewEmbeddedInDayHeader")) {
            let module = FeatureHelpers.getModule<{ dayHeaderEntityViewLabelVariants: Record<string, string> }>("PEP");
            this.rgDayHeaderEntityviewLabelVariant.setMandatory(true);

            let firstKey = null;
            if (module.dayHeaderEntityViewLabelVariants) {

                for (let key in module.dayHeaderEntityViewLabelVariants) {
                    if (!firstKey) firstKey = key;
                    this.rgDayHeaderEntityviewLabelVariant.addEntry(key, module.dayHeaderEntityViewLabelVariants[key]);
                }
                //this.hideNode(this.dayHeaderEntityviewOptions, false); // inzwischen noch ausgeblendet - wird sonst mit dem ganzen reload-Gehabe im Tabellenkopf aufwändig
            }

            if (!firstKey) {
                this.rgDayHeaderEntityviewLabelVariant.addEntry(true, "General_SetAsActive", true);
                this.rgDayHeaderEntityviewLabelVariant.setValue(true);
            } else {
                this.rgDayHeaderEntityviewLabelVariant.setValue(firstKey);
            }
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        on(document, "click", function (evt) { topic.publish("PEPclick_global", evt); });

        this.windowEx.CurrentSelectedClickMode = PEP.ClickMode.default;

        this.windowEx.DisplaySettings = {
            tableLayout: PEP.DspTableLayoutSettings.default,
            mainLabel: PEP.DspMainLabelSettings.default,
            smallInfo: PEP.DspSmallInfoSettings.bookingStatus,
            displayDayRecordSums: true,
            displayMainLabel: true,
            displayEmploymentValues: false,
            displayBookingStatus: true,
            //displayNoteInEditor: true,
            displayNoteInGrid: false,
            displaySpecialNotesInTableHeader: true,
            displayDayDescriptionInTableHeader: true,
            displayDayNotesInTableHeader: true,
            dayHeaderEntityviewLabelVariant: this.rgDayHeaderEntityviewLabelVariant.getValue()
        };

        this.setTitles(this.translations["PEP_MainTitle"], this.translations["PEP_Home_Title"]);
        let isLoading = this._checkUrlParams();

        this.loadFilterOptions();
        this.loadBaseRegistry();

        this.topBarContainer = <HTMLDivElement>document.getElementById("mainMenuGlobalSpace");

        if (this.topBarContainer != null) {
            this.UiModder.domAttr.set(this.topBarContainer, "innerHTML", "<div class='PEP_topContainer flex_row_center justify flex_gap' style='' id='PEP_topContainer'></div>");
            this.topBarContainer = <HTMLDivElement>this.topBarContainer.firstChild;
            //this.UiModder.domConstruct.place(this.mainHeading, this.topBarContainer);

        }

        this.addSubscription("sidebar/opened", lang.hitch(this, this._recalcWidthDelayed, 555));
        this.addSubscription("sidebar/closed", lang.hitch(this, this._recalcWidthDelayed, 555));

        //this._checkUrlParams(); // zu früh - Filterpanel womöglich nicht fertig!


        window.addEventListener("resize", lang.hitch(this, this._recalcWidthDelayed, 100));

        // DEV
        //this.showToast(this.translations["PEPhome__developmentNotice_short"], "dev", 9000, toasterIcons.info, this.translations["PEPhome__developmentNotice"], { close: true });
    }
}

export default mdsWidget(PepRosterStart);
